// based on Helper function from TCAT

import { useState, useEffect } from "react";
import { Button, Popover, Typography, Box, Stack, LinearProgress } from "@mui/material";
import { CURRENT_TUTORIAL_VERSION, TUTORIAL_STEPS } from "../constants";
import { useLocation } from "react-router-dom";

export default function TutorialPopper({openTutorial, setOpenTutorial, setTableTabValue}) {
  const [currentStep, setCurrentStep] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const { pathname } = useLocation()
  const currentTutorialSteps = TUTORIAL_STEPS[pathname]
  
  useEffect(() => {
    if (localStorage.getItem(pathname === '/mpo' ? 'mpoTutorialCompleted' : 'tutorialCompleted') !== CURRENT_TUTORIAL_VERSION || openTutorial) {
      startTutorial(0)
    }
  }, [openTutorial]);

  const startTutorial = (stepIndex) => {
    const step = currentTutorialSteps[stepIndex];
    if (!step) return;

    const anchor = document.querySelector(step.anchor);
    anchor?.classList.add('tutorial-highlight')
    setAnchorEl(anchor);
    setCurrentStep(stepIndex);
    setOpenTutorial(true);
  };

  // Function that handles moving one step forward or backward based on value of stepChange (1 or -1)
  const handleStepChange = (stepChange) => {
    if (currentStep < currentTutorialSteps.length) {
      if (currentTutorialSteps[currentStep + stepChange]?.title === 'Monitored Roads Tab') {
        setTableTabValue(2)
      } else if (currentTutorialSteps[currentStep + stepChange]?.title === 'Selected Roads Table') {
        setTableTabValue(1)
      } else if (currentTutorialSteps[currentStep + stepChange]?.title === 'Summary Table') {
        setTableTabValue(0)
      }
      anchorEl?.classList.remove('tutorial-highlight')
      startTutorial(currentStep + stepChange);
    } else {
      handleClose();
    }
  };

  const handleClose = () => {
    anchorEl?.classList.remove('tutorial-highlight')
    setAnchorEl(null);
    localStorage.setItem(pathname === '/mpo' ? 'mpoTutorialCompleted' : 'tutorialCompleted', CURRENT_TUTORIAL_VERSION); // Prevents repeat pop-ups
    setOpenTutorial(false);
  };

  return (
    <>
      { anchorEl !== null &&
        <Popover
          style={{ zIndex: 2002 }}
          slotProps={{ paper: { sx: { width: '40%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' } } }}
          open={openTutorial}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={ currentTutorialSteps[currentStep]?.anchorOrigin }
          transformOrigin={ currentTutorialSteps[currentStep]?.transformOrigin }
        >
          <Typography variant='h6' sx={{paddingX: 2, paddingTop: 2, textAlign: 'center' }}>{currentTutorialSteps[currentStep]?.title}</Typography>
          <Typography sx={{padding: 2}}>{currentTutorialSteps[currentStep]?.content}</Typography>
          <Stack direction='row' spacing={3} sx={{justifyContent: 'space-between', alignItems: 'center'}}>
            <Box sx={{padding: 2, width: '50%'}}>
              <LinearProgress variant='determinate' value={((currentStep+1)/currentTutorialSteps.length)*100} />
              <i>Step {currentStep+1} of {currentTutorialSteps.length}</i>
            </Box>
            <Box sx={{paddingY: 2, paddingRight: 2}}>
              <Button onClick={handleClose}>Close</Button>
              {currentStep > 0 && <Button onClick={() => handleStepChange(-1)} color="primary">Back</Button>}
              {currentStep < currentTutorialSteps.length - 1 && <Button onClick={() => handleStepChange(1)} color="primary">Next</Button>}
            </Box>
          </Stack>
        </Popover>
      }
    </>
  );
};